import React from "react";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next/";
import { VerticalDotsIcon } from "@aureskonnect/react-ui";
import ErrorToast from "@components/Common/ErrorTost";
import {
    storeVatRate,
    setUrlHistory,
    setIsAddVatRateOriginHistoryClicked,
    setDataIsUpdatedShops,
    setIsDeleteCheckClick,
    setFnDelete,
} from "../store";
import { store } from "../../../../components/VerticalLayout/store";
import { useFetchGlobal } from "../../../../api/hooks";
import { showSuccessToast } from "@components/Common/SuccessToast";

export function isExists(array1: any, array2: any) {
    let res: number = -1;
    array1.forEach((el1: any) => {
        if (array2.indexOf(el1) !== -1) {
            res++;
        }
    });
    return res;
}
export default function DropdownActionList({
    selectedRows,
    isModalOpened,
    setIsModalOpened,
    selectedIds,
    userID,
    franchiseID,
    typeDisplayShop,
    setTypeDisplayShop,
    setLimit,
}: any) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { oneShop, operatorID } = useSnapshot(store);
    const {
        dataFranchise,
        isAddVatRateOriginHistoryClicked,
        ListNumberBoutique,
        modify,
        isLoading,
    } = useSnapshot(storeVatRate);
    const uuidUser = localStorage.getItem("uuidUser");
    async function archiveVatRateAssocMulti(
        allAssociations: any[],
        ids: any,
        isSomeFavorite?: boolean
    ) {
        setLimit(2);
        const message =
            typeDisplayShop === "notArchived"
                ? t("The vat rate is successfully archived")
                : t("The vat rate is successfully restored");
        let OtherSiteArray: any = [];
        if (typeDisplayShop === "archived") {
            const select = true;
            if (dataFranchise.length > 0) {
                dataFranchise.forEach((el: any) => {
                    ids.forEach((elm: any) => {
                        let Id = elm;
                        if (el.Id === Id && el.archived === select) {
                            OtherSiteArray.push(Id);
                        }
                    });
                });
            }
        }

        // Vérifier si on a une TVA favorite avant de continuer
        if (isSomeFavorite === true) {
            ErrorToast(t("Please note, you cannot archive a favorite tva"));
            setDataIsUpdatedShops!(true);
        }

        // Vérifier si associations n'est pas vide
        if (!allAssociations || allAssociations.length === 0) {
            console.log("No associations to process, skipping API call");
            setDataIsUpdatedShops!(true);
            return;
        }

        try {
            const bulkPayload = {
                userId: userID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                franchiseId: franchiseID,
                associations: allAssociations,
            };
            const api = `${process.env.REACT_APP_API_V2_URL}/settings/general/vatRateArchiveAssocEditBulk`;
            const response: any = await fetchGlobal(api, {
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify(bulkPayload),
            });
            if (response.error) {
                throw new Error("Error while processing bulk archive!");
            }
            setDataIsUpdatedShops!(true);
            showSuccessToast(message);
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
        }
    }
    return (
        <React.Fragment>
            <div>
                <div className={`cmn_drp_BTmenu ${classnames("dropdown", {})}`}>
                    <VerticalDotsIcon
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        height={25}
                        width={25}
                        fill="black"
                    />
                    <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                    >
                        <div
                            className="dropdown-item pl-1 cmn_btn_BTlistActivated"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setTypeDisplayShop("notArchived");
                            }}
                        >
                            <span className="ml-2">
                                {t("Activated VAT rate(s)")} (
                                {ListNumberBoutique.nbrNotArchived})
                            </span>
                        </div>
                        <div
                            className="dropdown-item pl-1 cmn_btn_BTlistArchived"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setTypeDisplayShop("archived");
                            }}
                        >
                            <span className="ml-2">
                                {t("Archived vat rate(s)")} (
                                {ListNumberBoutique.nbrArchived})
                            </span>
                        </div>
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                var str = selectedIds.join(",");
                                var shops: string = "";
                                if (selectedRows.length > 0) {
                                    selectedRows.forEach((el: any) => {
                                        shops = shops + "," + el.shopId;
                                    });
                                    shops = shops.substring(1);
                                }

                                oneShop
                                    ? setUrlHistory(
                                          `${process.env.REACT_APP_API_V2_URL}/settings/general/vatRate/origin_history?userId=${userID}&franchiseId=${franchiseID}&typeDisplay=associate&idVatRates=${str}&shopIds=${shops}&operatorId=${operatorID}&uuidUser=${uuidUser}`
                                      )
                                    : setUrlHistory(
                                          `${process.env.REACT_APP_API_V2_URL}/settings/general/vatRate/origin_history?userId=${userID}&franchiseId=${franchiseID}&typeDisplay=associate&idVatRates=${str}&shopIds=${shops}&operatorId=${operatorID}&uuidUser=${uuidUser}`
                                      );
                                if (selectedIds.length === 1) {
                                    ErrorToast(
                                        t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )
                                    );
                                } else {
                                    setIsAddVatRateOriginHistoryClicked(
                                        !isAddVatRateOriginHistoryClicked
                                    );
                                }
                            }}
                            className={`cmn_btn_BThistory ${classnames(
                                " dropdown-item pl-1 pointer__clz",
                                {
                                    "not-allowed-icon__clz":
                                        (selectedIds !== undefined &&
                                            selectedIds.length === 0) ||
                                        isLoading === true,
                                }
                            )}`}
                        >
                            <span className="ml-2">{t("Historical")}</span>
                        </div>
                        {modify === true && (
                            <div
                                style={{ cursor: "pointer" }}
                                className={`${classnames(
                                    " dropdown-item pl-1 pointer__clz cmn_btn_BTarchived cmn_btn_BTunarchive",
                                    {
                                        "not-allowed-icon__clz":
                                            (selectedIds !== undefined &&
                                                selectedIds.length === 0) ||
                                            (typeDisplayShop === "archived" &&
                                                // eslint-disable-next-line array-callback-return
                                                dataFranchise.filter(function (
                                                    x: any
                                                ) {
                                                    if (
                                                        x.archived &&
                                                        selectedIds.indexOf(
                                                            x.Id
                                                        ) !== -1 &&
                                                        x
                                                    ) {
                                                        return x;
                                                    }
                                                }).length > 0) ||
                                            isLoading === true,
                                    }
                                )}`}
                                onClick={() => {
                                    let allAssociations: any[] = [];
                                    let ids: any = [];
                                    let idsTrace: any = [];
                                    let isSomeFavorite = false;

                                    selectedRows.forEach((elx: any) => {
                                        if (elx.isFavorite === true) {
                                            isSomeFavorite = true;
                                        } else if (
                                            elx[t("Shop")] === undefined ||
                                            elx[t("Shop")] === ""
                                        ) {
                                            if (
                                                idsTrace.indexOf(
                                                    `${elx.Id}${elx.shopId}`
                                                ) === -1
                                            ) {
                                                idsTrace.push(
                                                    `${elx.Id}${elx.shopId}`
                                                );
                                                ids.push(elx.Id);

                                                allAssociations.push({
                                                    shopId: elx.shopId,
                                                    data: {
                                                        id: elx.Id,
                                                        archived:
                                                            typeDisplayShop ===
                                                            "notArchived"
                                                                ? "true"
                                                                : "false",
                                                    },
                                                });
                                            }
                                        }
                                    });

                                    if (selectedIds.length <= 1) {
                                        ErrorToast(
                                            t(
                                                "Attention, it is a multiple action. Please select at least two items"
                                            )
                                        );
                                    } else {
                                        if (typeDisplayShop === "notArchived") {
                                            setFnDelete(() => {
                                                archiveVatRateAssocMulti(
                                                    allAssociations,
                                                    ids,
                                                    isSomeFavorite
                                                );
                                            });
                                            setIsDeleteCheckClick(true);
                                        } else {
                                            archiveVatRateAssocMulti(
                                                allAssociations,
                                                ids
                                            );
                                        }
                                    }
                                }}
                            >
                                <span className="ml-2">
                                    {typeDisplayShop === "notArchived"
                                        ? t("Archive")
                                        : t("Dearchive")}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
